<template>
  <div class="modal fade" :id="this.modalId" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"  data-backdrop="static">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header" v-if="this.title">
          <h5 class="modal-title" id="exampleModalLabel">{{this.title}}</h5>
          <button v-if="this.showCloseButton" type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>{{this.text}}</p>
        </div>
        <div class="modal-footer">
          <div class="row">
            <div class="col-6">
              <button type="button" v-on:click="callbackCloseButton()" class="btn btn-link btn-sm" data-dismiss="modal">{{this.buttonCloseText}}</button>
            </div>
            <div class="col-6">
              <button type="button" v-on:click="callbackConfirmButton()" class="btn btn-link btn-sm" data-dismiss="modal">{{this.buttonConfirmText}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  props:{
    modalId: {type: String} ,
    title: {type: String} ,
    text: {type: String},
    buttonConfirmText: {type: String},
    buttonCloseText: {type: String},
    showCloseButton: {type: Boolean},
    callbackConfirmButton: {type: Function},
    callbackCloseButton: {type: Function}
  }
}
</script>

<style scoped>
 .modal-title{
   font-family: 'VivoType', Sans-Serif;
 }
 .modal-body p{
   color: #757575;
 }
 .modal-footer button{
   font-family: 'VivoType', Sans-Serif;
   color: var(--primary);
   font-size: 0.875rem;
   text-transform: uppercase;
 }
</style>



// WEBPACK FOOTER //
// src/components/shared/Modal.vue